import { useEffect, useState } from "react";
import { CloseGreyIcon } from "../../../assets/icons";
import { SeoMetadataSettingsDTO } from "../../../models/seoMetadata/seoMetadata.response";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";
import { seoMetadataService } from "../../../services/seoMetadataService";

interface SeoMetadataViewProps {
    localId: string;
    onClose: () => void;
}

export default function SeoMetadataView({ localId, onClose }: SeoMetadataViewProps) {

    const [seoMetadata, setSeoMetadata] = useState<SeoMetadataSettingsDTO>({
        id: "",
        metaTitle: "",
        metaDescription: "",
        canonicalUrl: "",
        ogTitle: "",
        ogDescription: "",
        ogImageUrl: "",
        jsonLd: ""
    });

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();

    
    useEffect(() => {
        fetchSeoMetadata();
    }, [localId]);


    const handleSave = async () => {
        setLoading(true);
        try {
            const response = await seoMetadataService.UpdateForLocal(localId, {
                id: seoMetadata.id,
                metaTitle: seoMetadata.metaTitle,
                metaDescription: seoMetadata.metaDescription,
                canonicalUrl: seoMetadata.canonicalUrl ?? undefined,
                ogTitle: seoMetadata.ogTitle ?? undefined,
                ogDescription: seoMetadata.ogDescription ?? undefined,
                ogImageUrl: seoMetadata.ogImageUrl ?? undefined,
                jsonLd: seoMetadata.jsonLd ?? undefined,
            });

            if (response.success) {
                notify("success", "SeoMetadata uspešno ažuriran.");
            } else {
                notify("error", "Greška prilikom ažuriranja SeoMetadata.");
            }
        } catch (error) {
            notify("error", "Greška prilikom ažuriranja SeoMetadata.");
        } finally {
            setLoading(false);
        }
    }

    const fetchSeoMetadata = async () => {
        setLoading(true);
        try {
            const response = await seoMetadataService.GetSettingsByLocalId(localId);

            if (response.success && response.data) {
                setSeoMetadata(response.data);
            } else {
                notify("error", "Greška prilikom učitavanja SeoMetadata.");
            }
        } catch (error) {
            notify("error", "Greška prilikom učitavanja SeoMetadata.");
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <Loader />;
    }

    return (
        <section className="modal-section seo-metadata">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Upravljaj SeoMetadata za lokal</div>
                                <div className="description-text">Unesite detalje o SeoMetadata za lokaciu</div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form id="wf-form-" name="wf-form-" data-name="" method="get" className="modal-form" data-wf-page-id="69ac48ef647d89fc7969b2d6" data-wf-element-id="ea5616d5-6555-0f41-1566-1b82f29d50b2" data-turnstile-sitekey="0x4AAAAAAAQTptj2So4dx43e">
                                <div className="modal-form-div">
                                    <label className="modal-form-label">MetaTitle</label>
                                    <input className="form-input grey w-input" placeholder="" type="text"
                                        value={seoMetadata.metaTitle}
                                        onChange={(e) => setSeoMetadata({ ...seoMetadata, metaTitle: e.target.value })}
                                    />
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">MetaDescription</label>
                                    <input className="form-input grey w-input" placeholder="" type="text"
                                        value={seoMetadata.metaDescription}
                                        onChange={(e) => setSeoMetadata({ ...seoMetadata, metaDescription: e.target.value })}
                                    />
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">CanonicalUrl</label>
                                    <input className="form-input grey w-input" placeholder="" type="text"
                                        value={seoMetadata.canonicalUrl || ""}
                                        onChange={(e) => setSeoMetadata({ ...seoMetadata, canonicalUrl: e.target.value })}
                                    />
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">OgTitle</label>
                                    <input className="form-input grey w-input" placeholder="" type="text"
                                        value={seoMetadata.ogTitle || ""}
                                        onChange={(e) => setSeoMetadata({ ...seoMetadata, ogTitle: e.target.value })}
                                    />
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">OgDescription</label>
                                    <input className="form-input grey w-input" placeholder="" type="text"
                                        value={seoMetadata.ogDescription || ""}
                                        onChange={(e) => setSeoMetadata({ ...seoMetadata, ogDescription: e.target.value })}
                                    />
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">OgImageUrl</label>
                                    <input className="form-input grey w-input" placeholder="" type="text"
                                        value={seoMetadata.ogImageUrl || ""}
                                        onChange={(e) => setSeoMetadata({ ...seoMetadata, ogImageUrl: e.target.value })}
                                    />
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">JsonLd</label>
                                    <textarea placeholder="" className="form-textarea grey w-input"
                                        value={seoMetadata.jsonLd || ""}
                                        onChange={(e) => setSeoMetadata({ ...seoMetadata, jsonLd: e.target.value })}
                                    ></textarea>
                                </div>
                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium" onClick={handleSave}>
                                <div>Sacuvaj izmene</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}